import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  return data
}

const fetchPayoutLinksList = (mid: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.payoutLinksList,
    method: 'POST',
    config: sitConfig(tokens),
    body: {
      mid,
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { fetchPayoutLinksList }
